interface ShareLinkFieldProps {
  shareUrl?: string | null;
  label?: string;
}

export function ShareLinkField({ shareUrl, label }: ShareLinkFieldProps) {
  return (
    <div>
      {label ? (
        <label className="mb-2 block text-xs text-[#383838]">{label}</label>
      ) : null}
      <div
        className="flex min-h-[38px] items-center rounded-lg border border-[#e8e7e7] bg-white px-2 py-[7px] shadow-[inset_1px_1px_3px_0_rgba(118,117,116,0.2)]"
        aria-busy={!shareUrl}
      >
        {shareUrl ? (
          <span
            data-hook="share-link"
            className="truncate text-sm text-[#151414]"
            title={shareUrl}
          >
            {shareUrl}
          </span>
        ) : (
          <span
            data-hook="share-link-loading"
            className="ml-auto h-4 w-4 animate-spin rounded-full border-2 border-transparent border-t-[#767574]"
          />
        )}
      </div>
    </div>
  );
}
